import React, { useState } from 'react';
import {HiChevronUp, HiChevronDown } from 'react-icons/hi2';
import styles from './FAQItem.module.css';


export default function FAQItem({ index, question, children, isOpen, onToggle }) {
  if (!question) return null;
  return (
    <div className={styles.faqItem}>
      {index === 0 ? <h3>FAQs</h3> : null}

      <div className={styles.faqHeader} onClick={() => onToggle(index)}>
        <span>{question}</span>
        {isOpen
          ? <HiChevronUp className={styles.faqIcon} />
          : <HiChevronDown className={styles.faqIcon} />}
      </div>

      {isOpen && (
        <div className={styles.faqContent}>
          {children}
        </div>
      )}
    </div>
  );
}

function FAQItem_({ index, question, children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.faqItem}>
	{index == 0 ? <h3 >FAQs</h3>: <></>}
      <div className={styles.faqHeader} onClick={() => setOpen(!open)}>
        <span>{question}</span>
        {open ? <HiChevronUp className={styles.faqIcon} /> : <HiChevronDown className={styles.faqIcon} />}
      </div>
      {open && <div className={styles.faqContent}>{children}</div>}
    </div>
  );
}

